import './index.erb';
import './index.rb';
import CookieManager from 'utils/cookie_manager';

class TimeBox {
  constructor() {
    this.$context = $('#time-box');
    this.cookieName = 'renewal_timebox';

    if (!this.$context.length) {
      return false;
    }

    this.bind();
  }

  bind() {
    if (
      !this.$context.hasClass('open') &&
      !CookieManager.getCookie(this.cookieName)
    ) {
      this.$context.addClass('open');
    }

    this.bindClose();
    this.bindVisit();
  }

  bindClose() {
    this.$context.find('.close-button').on('click', () => {
      CookieManager.setExpirationCookie(this.cookieName, true, 1);
      this.$context.removeClass('open');

      UserTracker.emit('event', {
        eventName: 'UI Interaction',
        data: {
          context: 'renewal timebox',
          type: 'close',
          action: 'click'
        }
      });
    });
  }

  bindVisit() {
    this.$context.find('.btn-info').on('click', () => {
      CookieManager.setExpirationCookie(this.cookieName, true, 1);

      UserTracker.emit('event', {
        eventName: 'UI Interaction',
        data: {
          context: 'renewal timebox',
          type: 'link',
          action: 'click'
        }
      });
    });
  }
}

const init = () => new TimeBox();

if (window.isTurbolinksLoading) {
  document.addEventListener('turbolinks:load', () => init());
} else {
  init();
}
